export default __webpack_public_path__ + "static/logo-6-80f70d6884c42ef24de1e95f9d70c181.webp";